import { Card, DataFetchWrapper } from "@tfg/ui"
import { useContext } from "react"

import { useFindOperationChainItemsQuery } from "~/pages/Admin/Ingestion/OpChains/hooks/useFindOperationChainItemsQuery"
import { OpChainContext } from "~/pages/Admin/Ingestion/OpChains/store/op-chain-context"

import { OpChainContent } from "./OpChainContent"

export function OpChainManagementContainer() {
  const { opChainIdSelected } = useContext(OpChainContext)

  const query = useFindOperationChainItemsQuery({
    operationChainId: opChainIdSelected ?? "", // TODO : when prod feature remove the way current opChainIdSelected is set
  })

  if (!opChainIdSelected) {
    return null
  }

  return (
    <Card>
      <DataFetchWrapper query={query}>
        {({ data }) => (
          <OpChainContent
            activityItems={data.data}
            operationChainId={opChainIdSelected}
          />
        )}
      </DataFetchWrapper>
    </Card>
  )
}
